// components/Modal.jsx
function Modal({ isOpen, onClose, title, children, className }) {
  if (!isOpen) return null;
  console.log('Rendering Modal with title:', title); // Debug log
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className={`bg-white dark:bg-gray-700 rounded-lg p-5 w-full ${className || 'max-w-lg'} transform transition-all duration-300 scale-100`}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-medium text-gray-800 dark:text-gray-100">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-100"
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default Modal;